<template>
    <main
        class="posts-v2"
        id="js-page-content"
        role="main"
    >
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('menu.tickets.list') }}</div>
        </portal>

        <header class="posts-hero">
            <div class="posts-hero-text">
                <h1 class="posts-hero-title">{{ $t('menu.tickets.list') }}</h1>
                <p class="posts-hero-sub">{{ totalLabel }}</p>
            </div>
            <MultipleListCreate class="posts-multi-list" />
        </header>

        <section class="posts-card">
            <TabPosts
                ref="tabPosts"
                :isLoadingPosts="isLoadingPosts"
            />
        </section>
    </main>
</template>

<script>
import TabPosts from '@/components/Model/Post/TabPosts'
import { mapActions, mapState } from 'vuex'
import MultipleListCreate from '@/components/UI/MultipleListCreate'

export default {
    name: 'Posts',
    data() {
        return {
            modifStatus: false,
            divCategorie: false,
            roundedCategorie: true,
            divFormulaire: false,
            roundedFormulaire: true,
            divStatus: false,
            roundedStatus: true,
            isLoadingPosts: false
        }
    },
    components: { TabPosts, MultipleListCreate },
    computed: {
        ...mapState('post', {
            posts: (state) => state.posts,
            postsFilters: (state) => state.postsFilters
        }),
        totalLabel() {
            const n = this.posts && this.posts.total ? this.posts.total : 0
            const formatted = new Intl.NumberFormat(this.$i18n.locale).format(n)
            const key = n === 1 ? 'post.page.list_count_one' : 'post.page.list_count_other'
            return this.$t(key, { count: formatted })
        },
    },
    created() {
        let postsPromise = this.getPosts()
        let postsFiltersPromise = this.getPostsFilters()
        let statusesPromise = this.getStatus()
        Promise.all([postsPromise, postsFiltersPromise, statusesPromise]).then(
            () => {
                this.isLoadingPosts = true
            }
        )
    },
    methods: {
        ...mapActions('post', ['getPosts', 'getPostsFilters']),
        ...mapActions('status', ['getStatus'])
    }
}
</script>

<style scoped>
.posts-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.posts-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--v2-space-4);
    margin-bottom: var(--v2-space-5);
}

.posts-hero-text {
    min-width: 0;
}

.posts-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.posts-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.posts-multi-list {
    flex-shrink: 0;
}

.posts-card {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
}

@media (max-width: 900px) {
    .posts-v2 {
        padding: 16px 18px 32px;
    }

    .posts-hero {
        flex-direction: column;
        align-items: stretch;
        gap: var(--v2-space-3);
    }

    .posts-hero-title {
        font-size: 1.375rem;
    }
}
</style>
